import { BanSection } from './BanSection'
import { withBanSection } from './withBanSection'

const ConnectedBanSection = withBanSection(BanSection)

export { ConnectedBanSection as BanSection }
